import * as THREE from 'three';

/**
 * Calls fn for every Mesh carrying `key` in its userData, either on itself or inherited from the nearest marked
 * ancestor (GLTFLoader turns a multi-material node into a Group of Meshes and puts the extras on the Group).
 */
export function forEachMarkedMesh(root: THREE.Object3D, key: string, fn: (mesh: THREE.Mesh, value: unknown) => void): void {
  const visit = (o: THREE.Object3D, inherited: unknown): void => {
    const value = o.userData[key] ?? inherited;
    if (o instanceof THREE.Mesh && value !== undefined) fn(o, value);
    for (const child of o.children) visit(child, value);
  };
  visit(root, undefined);
}
